import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api-client';

/**
 * The callbacks the Tâches tab lists. The ⌘K « Tâches en retard (n) » count,
 * the Tâches menu badge and the home page read the same query, so the number
 * matches the list it opens (it was counted from the dialer's capped call
 * list, one customer only).
 *
 * ADR-024: with an active customer, only that customer's callbacks
 * (`customer_id`); the server adds the organisation and, for a viewer, its
 * customer list (entities-followups-scope.integration.test.ts).
 */
export interface ScheduledCallback {
  id: string;
  call_outcome?: string | null;
  follow_up_at?: string | null;
  follow_up_completed?: boolean | null;
  customer_id?: string | null;
  [k: string]: unknown;
}

/** The active customer as an entity filter (ADR-024); none = the role's whole scope. */
export function customerFilter(customerId: string | null | undefined): Record<string, unknown> {
  return customerId ? { customer_id: customerId } : {};
}

export function scheduledCallbacksFilter(customerId: string | null | undefined): Record<string, unknown> {
  return { call_outcome: 'callback_requested', ...customerFilter(customerId) };
}

export function useScheduledCallbacks(clientEmail: string | null | undefined, enabled = true, customerId: string | null = null, poll = true) {
  return useQuery({
    queryKey: ['scheduled-callbacks', clientEmail, customerId],
    queryFn: () =>
      api.entities.ParallelCall.filter<ScheduledCallback>(
        scheduledCallbacksFilter(customerId),
        '-created_date',
        500,
      ),
    enabled: !!clientEmail && enabled,
    refetchInterval: poll ? 30000 : false,
  });
}
